import { useState, useRef, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const ShowDescription = ({ description, maxHeight = 200 }) => {
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    // Check if content height exceeds maxHeight to determine if we need the "See More" button
    if (contentRef.current && contentRef.current.scrollHeight > maxHeight) {
      setShowButton(true);
    }
  }, [description, maxHeight]);

  // Function to toggle expanded state
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  // Handle description text to properly break long words without spaces
  const formatDescription = (text) => {
    // If text is null or undefined, return empty string
    if (!text) return "";

    // Return the text as is, word-break CSS will handle the display
    return text;
  };

  return (
    <div className="m-1 w-full">
      <div
        ref={contentRef}
        className={`overflow-hidden whitespace-pre-line break-words text-gray-600 transition-all duration-300`}
        style={{
          maxHeight: expanded ? "none" : `${maxHeight}px`,
          wordBreak: "break-word",
          overflowWrap: "break-word",
          maxWidth: "100%",
        }}
      >
        {formatDescription(description)}
      </div>
      <div className="flex w-full justify-center align-middle">
        {showButton && (
          <button
            onClick={toggleExpanded}
            className="mt-2 flex items-center justify-center gap-1 font-medium text-[#042F0C] focus:outline-none"
          >
            {expanded ? (
              <>
                See Less <ChevronUp size={16} />
              </>
            ) : (
              <>
                See More <ChevronDown size={16} />
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default ShowDescription;
